<template>
  <div class="flex items-center justify-center w-full">
    <div class="flex items-center p-1 space-x-4 bg-gray-100 rounded-full">
      <router-link
        :to="'/'"
        v-slot="{ isActive, isExactActive }"
        class="flex items-center"
      >
        <span
          class="px-3 py-2 text-xs text-gray-500 rounded-full"
          :class="isActive && isExactActive ? 'bg-white' : ''"
          >Collect</span
        >
      </router-link>
      <router-link
        :to="'/create'"
        v-slot="{ isActive, isExactActive }"
        class="flex items-center"
      >
        <span
          class="px-3 py-2 text-xs text-gray-500 rounded-full"
          :class="isActive && isExactActive ? 'bg-white' : ''"
          >Create</span
        >
      </router-link>
    </div>
  </div>
</template>
